/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DialCode } from './DialCode';
import {
    DialCodeFromJSON,
    DialCodeFromJSONTyped,
    DialCodeToJSON,
    DialCodeToJSONTyped,
} from './DialCode';

/**
 * 
 * @export
 * @interface GetGeography
 */
export interface GetGeography {
    /**
     * 
     * @type {Array<DialCode>}
     * @memberof GetGeography
     */
    countries: Array<DialCode>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetGeography
     */
    states: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof GetGeography
     */
    provinces: { [key: string]: string; };
}

/**
 * Check if a given object implements the GetGeography interface.
 */
export function instanceOfGetGeography(value: object): value is GetGeography {
    if (!('countries' in value) || value['countries'] === undefined) return false;
    if (!('states' in value) || value['states'] === undefined) return false;
    if (!('provinces' in value) || value['provinces'] === undefined) return false;
    return true;
}

export function GetGeographyFromJSON(json: any): GetGeography {
    return GetGeographyFromJSONTyped(json, false);
}

export function GetGeographyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGeography {
    if (json == null) {
        return json;
    }
    return {
        
        'countries': ((json['countries'] as Array<any>).map(DialCodeFromJSON)),
        'states': json['states'],
        'provinces': json['provinces'],
    };
}

export function GetGeographyToJSON(json: any): GetGeography {
    return GetGeographyToJSONTyped(json, false);
}

export function GetGeographyToJSONTyped(value?: GetGeography | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'countries': ((value['countries'] as Array<any>).map(DialCodeToJSON)),
        'states': value['states'],
        'provinces': value['provinces'],
    };
}

